// Fallback to localhost:8002 when `REACT_APP_API_BASE_URL` is not set
export const API_BASE_URL = process.env.REACT_APP_API_BASE_URL|| 'http://172.25.1.10:8002';

